'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.refreshUser = exports.updateUser = exports.userMarkAsDisconnected = exports.userDisconnect = exports.userConnect = undefined;

var _timeUtil = require('../../common/utils/timeUtil');

var _userConstants = require('./userConstants');

// Utils
var userConnect = exports.userConnect = function userConnect(userId) {
    return {
        type: _userConstants.USER_CONNECT,
        userId: userId,
        timestamp: (0, _timeUtil.getTimestamp)()
    };
};

// Constants
var userDisconnect = exports.userDisconnect = function userDisconnect(userId) {
    return {
        type: _userConstants.USER_DISCONNECT,
        userId: userId,
        timestamp: (0, _timeUtil.getTimestamp)()
    };
};

var userMarkAsDisconnected = exports.userMarkAsDisconnected = function userMarkAsDisconnected(userId) {
    return {
        type: _userConstants.USER_MARK_AS_DISCONNECTED,
        userId: userId,
        timestamp: (0, _timeUtil.getTimestamp)()
    };
};

var updateUser = exports.updateUser = function updateUser(_ref) {
    var userId = _ref.userId,
        changes = _ref.changes,
        _ref$sync = _ref.sync,
        sync = _ref$sync === undefined ? true : _ref$sync;
    return {
        type: _userConstants.USER_UPDATE,
        userId: userId,
        changes: changes,
        sync: sync
    };
};

/**
 * Update user merges changes onto the user, refresh user overwrites that user.
 */
var refreshUser = exports.refreshUser = function refreshUser(_ref2) {
    var userId = _ref2.userId,
        user = _ref2.user;
    return {
        type: _userConstants.USER_REFRESH,
        userId: userId,
        user: user
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/common/users/userActions.js
// module id = 2289
// module chunks = 0